import { faSave } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormikErrors, useFormik } from 'formik';
import React, { useEffect } from 'react';
import VoxelSelectPalette from '../../../components/muiLegacy/Select/VoxelSelectPalette';
import VoxelFormPanel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanel';
import VoxelFormPanelActionSubmit from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionSubmit';
import VoxelPanelActions from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelPanelActions';
import { AnalysisColorPaletteGq } from '../../../graphql/projects/models/AnalysisColorPaletteGq';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import { usersApiService } from '../../../graphql/users/usersApiService';
import { useUserDefaults } from '../../../logic/otherUtilities/useUserDefaults';
import VoxelFormPanelContent from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelContent';

export interface FormState {
  palette: AnalysisColorPaletteGq;
}

export interface UserPaletteFormProps {
  user: CurrentUserGq;
  setDirty: (dirty: boolean) => void;
  setSave: (saveFunction: () => Promise<unknown>) => void;
  reload: () => Promise<unknown>;
}

const UserPaletteForm: React.FC<UserPaletteFormProps> = ({
  user,
  setDirty,
  setSave,
  reload,
}) => {

  const defaults = useUserDefaults(user);
  const mutation = usersApiService.mutations.useUpdateUserPalette();
  const formikProps = useFormik<FormState>({
    initialValues: {
      palette: defaults.palette,
    },
    enableReinitialize: true,
    validateOnChange: true,
    validate: (values) => {
      const errors: FormikErrors<FormState> = {};
      return errors;
    },
    onSubmit: (values, actions) =>
      mutation({ paletteId: values.palette?.id > 0 ? values.palette?.id : null, })
        .catch((error) => console.log(error))
        .then(() => reload()),
  });

  useEffect(() => setSave(formikProps.submitForm), [formikProps.submitForm]);
  useEffect(() => {
    setDirty(formikProps.dirty);
    return () => setDirty(false);
  }, [formikProps.dirty]);

  return (
    <VoxelFormPanel
      title={<span>Color palette</span>}
      subtitle={
        <span>Default color theme used by charts in the project analysis section.</span>
      }
    >
      <VoxelFormPanelContent>
        <VoxelSelectPalette
          labelPosition="top"
          selectedPalette={formikProps.values?.palette}
          setSelectedPalette={(option) => formikProps.setFieldValue('palette', option)}
          disabled={formikProps.isSubmitting}
        />
      </VoxelFormPanelContent>
      <VoxelPanelActions>
        <VoxelFormPanelActionSubmit
          title={'Save changes'}
          onClick={formikProps.submitForm}
          disabled={
            formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty
          }
          endIcon={<FontAwesomeIcon icon={faSave} />}
        />
      </VoxelPanelActions>
    </VoxelFormPanel>
  );
};

export default UserPaletteForm;
